module.exports = __webpack_public_path__ + "img/13m.178f81e6.jpg";